import React, { useEffect, useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TabsHeader from "../components/TabsHeader";
import Place from "@mui/icons-material/Place";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import { postConsulta } from "../helpers/contacto";
import toast from "react-hot-toast";
import useLocation from "../hooks/useLocation";
import pushDataLayerEvent from 'react-gtm-module';
import { useNavigate } from "react-router-dom";
import imgIntro from "../assets/images/nodinamic/contacto.jpg";
import { useContactoFormValidator } from "../hooks/useContactoFormValidator";
import { Helmet, HelmetProvider } from "react-helmet-async";

const Contact = () => {
  const [activoContact, setActivoContact] = useState(false);
  const [localidades, setLocalidades] = useState([]);
  const navigate = useNavigate();
  const [formValue, setFormValue] = useState({
    name: "",
    origin: "0",
    email: "",
    codCountry: "54",
    codArea: "",
    phone: "",
    province: "",
    city: "",
    message: "",
    subject: "",
    mundo: false,
  });

  const { countries, provinces, searchLocalidades } = useLocation();
  const { errors, validateForm, onBlurField } =
    useContactoFormValidator(formValue);

  const handleChange = ({ target }) => {
    const field = target.name;

    const nextFormState = {
      ...formValue,
      [field]: target.value,
    };

    if (target) {
      setFormValue({
        ...formValue,
        [target.name]: target.value,
      });

      if (target.name === "province") {
        const localities = searchLocalidades(target.selectedOptions[0].id);
        setLocalidades(localities);
      }
      if (errors[field].dirty) {
        validateForm({
          form: nextFormState,
          errors,
          field,
        });
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { isValid } = validateForm({
      form: formValue,
      errors,
      forceTouchErrors: true,
    });
    if (!isValid) return;

    postConsulta(formValue)
      .then((respuesta) => {
        if (respuesta) {
          toast.success("Formulario enviado!");
        }
        if (respuesta.errors) {
          return window.alert(respuesta.errors[0].msg);
        }
        if (respuesta.msg) {
          window.alert(respuesta.msg);
        }
        setFormValue({
          origin: "0",
          company: "",
          name: "",
          email: "",
          dni_cuit: "",
          codCountry: "54",
          codArea: "",
          phone: "",
          province: "",
          city: "",
          message: "",
          subject: "",
          mundo: false,
        });

      })
      .catch((error) => {
        if (Object.keys(errors).length !== 0) {
          toast.error("Hubo un error al enviar el formulario");
        }
      });

    pushDataLayerEvent({
      event: 'formContacto',
      'formulario-id': `${e.target.id}`
    });
  };


  useEffect(() => {
    setActivoContact(true);
  }, []);

  const navigateWorkWithUs = () => {
    navigate("/trabajar-con-nosotros");
  }

  return (
    <>
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
          <title>Contacto | Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón</title>
          <meta name="title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta name="description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta itemProp="image" content="https://tensolite.com/images/redes.png" />
          <meta name="author" content="Sitenso"></meta>

          <meta property="og:type" content="website" />
          <meta property="og:url" content={`https://tensolite.com`} />
          <meta property="og:title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta property="og:description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta property="og:image" content="https://tensolite.com/images/redes.png" />

          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={`https://tensolite.com`} />
          <meta property="twitter:title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta property="twitter:description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta property="twitter:image" content="https://tensolite.com/images/redes.png" />
        </Helmet>
      </HelmetProvider>
      <div
        id="contacto-section"
        aria-labelledby="contactanos"
        className="bg-fullpage"
      >
        <img src={imgIntro} alt="" className="h60" />

        <div className="container">
          <header id="contactanos">
            <h1>Contáctanos</h1>
            <p>
              <b>Estamos a disposición para despejar todas tus dudas</b>
            </p>
            <p>Muchas Gracias</p>
          </header>
          <TabsHeader activoContact={activoContact} />
        </div>
      </div>


      <div className="container">
        <div className="workWithUsContainer">
          <div className="workWithUsButton" onClick={navigateWorkWithUs}>
            <h4 className="titleWorkWithUs" >¿QUERÉS TRABAJAR CON NOSOTROS?</h4>
          </div>
          <div className="uploadCVContainer" onClick={navigateWorkWithUs}>
            <h5 className="uploadCVText">HACE CLICK</h5>
            <h5 className="uploadCVText">AQUÍ</h5>
          </div>
        </div>
        <section className="info-contacto-sucursal">

          <div className="col-md-12">
            <h2>Fábrica Tucumán</h2>
            <address className="small-contacto">
              <p>
                <CallIcon aria-label="Teléfono" titleAccess="Teléfono" />
                <a href="tel: +543814372215" target="_blank" rel="noopener noreferrer">
                  +54 381 437 2215
                </a>
                <br />
                <Place aria-label="Ubicación" titleAccess="Ubicación" />
                <a
                  href="https://g.page/Tensolite_sa?share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ruta Nac., 9 1298, T4101 Tafí Viejo, Tucumán
                </a>
                <br />
                <EmailIcon aria-label="Email" titleAccess="Email" />
                <a
                  href="mailto:comunicaciones@tensolite.com"
                  aria-label="enviar mail a comunicaciones@tensolite.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  comunicaciones@tensolite.com
                </a>
              </p>
            </address>
          </div>
          {/* datos fabrica cba */}
          <div className="col-md-12">
            <h2>Fábrica Córdoba</h2>
            <address className="small-contacto">
              <p>
                <CallIcon aria-label="Teléfono" titleAccess="Teléfono" />
                <a href="tel: +543814372215" target="_blank" rel="noopener noreferrer">
                  +54 381 437 2215
                </a>
                <br />
                <Place aria-label="Ubicación" titleAccess="Ubicación" />
                <a
                  href="https://goo.gl/maps/Y6arLSny8jhLYCtj7"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ruta 9 Km 666, X5960 Río Segundo, Córdoba
                </a>
              </p>
            </address>
          </div>
        </section>
        <section id="institucional__contacto">
          <form id="form-contacto" className="settings__form-styles" onSubmit={handleSubmit}>
            <fieldset className="col-sm-12 col-md-6 col-lg-6 settings__col-izquierda">

              <legend>Datos de Contacto</legend>
              <div className="mb-4 col-100">
                <input
                  id="nombre-cliente"
                  type="text"
                  name="name"
                  placeholder="Nombre"
                  value={formValue.name}
                  onChange={handleChange}
                  onBlur={onBlurField}
                  maxlength={30}
                  minlength={3}
                  pattern="[a-z,A-Z, ]{2,25}"
                  className={`${errors.name.error ? "red-advertise" : ""} `}
                  required
                />
                {errors.name.dirty && errors.name.error ? (
                  <p className="errors-msg">{errors.name.message}</p>
                ) : null}
              </div>
              <div className="mb-4 col-100">
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formValue.email}
                  onChange={handleChange}
                  onBlur={onBlurField}
                  placeholder="Email de contacto"
                  className={`${errors.email.error ? "red-advertise" : ""} `}
                  maxlength={50}
                  required
                />
                {errors.email.dirty && errors.email.error ? (
                  <p className="errors-msg">{errors.email.message}</p>
                ) : null}
              </div>
              <div className="mb-2 col-100">
                <div className="row">
                  <div className="col-3">
                    <select name="codCountry" onChange={handleChange}>
                      {countries?.country?.map((country) => (
                        <option
                          value={country?.country_phone_code}
                          id={country?.country_phone_code}
                          selected={country?.country_phone_code === 54}
                        >
                          {`+ ${country?.country_phone_code} (${country?.country_short_name})`}
                        </option>
                      ))}
                    </select>
                    {errors.codCountry.dirty && errors.codCountry.error ? (
                      <p className="errors-msg">{errors.codCountry.message}</p>
                    ) : null}
                  </div>
                  <div className="col-4">
                    <input
                      id="cod-area"
                      name="codArea"
                      type="tel"
                      value={
                        formValue.codArea.length < 2000000
                          ? formValue.codArea
                          : ""
                      }
                      onChange={handleChange}
                      onBlur={onBlurField}
                      placeholder="Cod. área (Ej: 381)"
                      className={`${errors.codArea.error ? "red-advertise" : ""
                        } `}
                      maxlength={10}
                      minlength={2}
                      required
                    />
                    {errors.codArea.dirty && errors.codArea.error ? (
                      <p className="errors-msg">{errors.codArea.message}</p>
                    ) : null}
                  </div>
                  <div className="col-5">
                    <input
                      id="telefono"
                      name="phone"
                      type="tel"
                      title="Solo debes ingresar numeros"
                      value={formValue.phone}
                      onChange={handleChange}
                      onBlur={onBlurField}
                      placeholder="Teléfono"
                      className={`${errors.phone.error ? "red-advertise" : ""
                        } `}
                      maxlength={20}
                      minlength={2}
                      required
                    />
                    {errors.phone.dirty && errors.phone.error ? (
                      <p className="errors-msg">{errors.phone.message}</p>
                    ) : null}
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset className="col-12 col-sm-12 col-md-6 col-lg-6 settings__col-derecha">
              <legend className="id-section-contacto">Datos generales</legend>

              <div className="mb-4 col-100">
                <select name="province" onChange={handleChange}>
                  <option selected disabled>
                    Provincia
                  </option>
                  {provinces?.province?.map((province) => (
                    <option
                      value={province?.province_name}
                      id={province?.province_id}
                    >
                      {province?.province_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4 col-100">
                <select name="city" onChange={handleChange}>
                  <option>Localidad</option>
                  {localidades?.map(
                    (loc) =>
                      loc?.localitie_type === "localities" && (
                        <option
                          value={loc?.locality_name}
                          id={loc?.locality_id}
                        >
                          {loc?.locality_name}
                        </option>
                      )
                  )}
                </select>
              </div>
            </fieldset>
            <fieldset className="col-12 d-flex flex-wrap">
              <legend className="col-12">¿Cuál es tu consulta?</legend>

              <div className="mb-4 col-12 col-sm-12 col-md-6 col-lg-6 settings__col-izquierda">
                <select
                  onChange={handleChange}
                  name="subject"
                  value={formValue.subject}
                  onBlur={onBlurField}
                  className={`${errors.subject.error ? "red-advertise" : ""} `}
                  required
                >
                  <option value={0}>Selecciona una opción</option>
                  <option value={1}>Cotizar productos especiales</option>
                  <option value={2}>Consulta técnica producto especial</option>
                  <option value={3}>Consulta comercial</option>
                  <option value={4}>Consulta técnica</option>
                  <option value={5}>Quiero visitar la fábrica</option>
                  <option value={6}>Soy Corralón y quiero comprar</option>
                </select>
                {errors.subject.dirty && errors.subject.error ? (
                  <p className="errors-msg">{errors.subject.message}</p>
                ) : null}
              </div>
              <div className="mb-4 col-12 col-sm-12 col-md-6 col-lg-6 settings__col-derecha">
                <textarea
                  id="descripcion"
                  name="message"
                  type="text"
                  value={formValue.message}
                  onChange={handleChange}
                  onBlur={onBlurField}
                  placeholder="Ingrese su consulta (POR FAVOR, ESTE FORMULARIO NO ES PARA CARGAR CURRICULUM)"
                  className={`shadow2 ${errors.message.error ? "red-advertise" : ""} `}
                  maxlength={400}
                  minlength={3}
                  required
                />
                {errors.message.dirty && errors.message.error ? (
                  <p className="errors-msg">{errors.message.message}</p>
                ) : null}
              </div>
            </fieldset>
            <div className="col-12">
              <button
                type="submit"
                className="settings_button-pleno bg-p-secondary mb-4 float-end button_mobile d-flex justify-content-between"
              >
                Enviar <ArrowForwardIcon />
              </button>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default Contact;
